import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  padding: ${rem(20)};
  width: ${rem(320)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)};
  }

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(60)};
  }

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
    overflow: hidden;
  }
`

interface Props {
  to: string
}

function OfferCarouselLookingForSomethingElse(props: Props) {
  const { to } = props
  const intl = useIntl()

  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center" gap={24}>
      <VerticalSpacer gap={8}>
        <Heading align="center" variant="heading5">
          {intl.formatMessage({
            id: 'Mb9WCwcTmvuw9WXIojcq',
            defaultMessage: 'Looking for something else?',
          })}
        </Heading>
      </VerticalSpacer>
      <TextButton kind="primary" size="medium" shape="square" to={to}>
        {intl.formatMessage({
          id: 'XMHO6v1XbawuUzHKS0Pl',
          defaultMessage: 'View all',
        })}
      </TextButton>
    </Container>
  )
}

export default memo(OfferCarouselLookingForSomethingElse)
